import styled from '@emotion/styled/macro';

import { COLUMN_IDS } from './keys';

export const Container = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  margin: '0 -10px',
  backgroundColor: props.theme.colors.pageWrapper,
  [`
  & [data-column="${COLUMN_IDS.ID}"]`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: '20px !important',
  },
  [`
  & [data-column="${COLUMN_IDS.CRYPTO_AMOUNT}"],
  & [data-column="${COLUMN_IDS.FIAT_AMOUNT}"]
  `]: {
    textAlign: 'right',
    '& .MuiTableSortLabel-root': {
      flexDirection: 'row-reverse',
    },
  },
}));
